module.exports = __webpack_public_path__ + "static/media/popeye_head.aceaacd5.svg";